import React, { Component } from 'react'
import { connect } from 'react-redux'

import Datagrid from '@/ui/DataTable/Datagrid'
import ListTable from '@/ui/DataTable/List'

// Already themed when importing from collection
import { ButtonField, TextField, IndexField } from '@/ui/Data' // eslint-disable-line
import { EditButton, Button, ButtonGroup } from '@/ui/Button'
import { Container, Row, Cell } from '@/ui/Element'
import { Tooltip } from '@/ui/Tooltip'

import { crudDelete } from '@/state/actions/data'
import { showModal, hideModal } from '@/state/actions/modal'
import { routeComponentsEdit } from '@/state/actions/routes'

import pad from '@/helpers/pad'
import DeleteIcon from '@/icons/Delete'
import EditIcon from '@/icons/Edit'

class Components extends Component {
  close = () => {
    this.props.dispatch(hideModal())
  }

  delete = record => {
    this.props.dispatch(
      crudDelete('components', record.id, false, { message: `${record.title} deleted.` }),
    )
    this.props.dispatch(hideModal())
  }

  edit = record => {
    this.props.dispatch(routeComponentsEdit(record.id))
  }

  remove = record => {
    this.props.dispatch(
      showModal({
        title: 'Permanently delete $title?',
        record: record,
        content:
          `This will permanently delete $title from the component list and ` +
          `it will no logner be accessible to anyone. All related items will ` +
          `remain. This action is irreversible.`,
        buttons: [
          <Button classes="inverted" key="cancel" onClick={this.close}>
            Cancel
          </Button>,
          <Button classes="danger" key="delete" onClick={() => this.delete(record)}>
            Delete
          </Button>,
        ],
      }),
    )
  }

  render() {
    const { theme, startingNo, ...props } = this.props

    return (
      <Container>
        <Row spacing="double">
          <Cell>
            <ListTable {...props} resource="components" title={false}>
              <Datagrid startingNo={startingNo}>
                <IndexField label="Nr." width="calc(2.3rem + 3em)" sortable={false} format={pad} />
                <EditButton source="title" title={false} click={this.edit} theme={theme} />
                <TextField source="identifier" label="Identifier" />
                <ButtonGroup width="10rem" label="Manage">
                  <ButtonField
                    tag="div"
                    sortable={false}
                    click={this.edit}
                    classes={['flex-center', 'flex-middle']}
                  >
                    <Tooltip content="Edit component">
                      <EditIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                  <ButtonField tag="div" sortable={false} click={this.remove}>
                    <Tooltip content="Delete component">
                      <DeleteIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                </ButtonGroup>
              </Datagrid>
            </ListTable>
          </Cell>
        </Row>
      </Container>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    startingNo:
      (state.rest.components.list.params.page - 1) * state.rest.components.list.params.perPage,
  }
}

export default connect(mapStateToProps)(Components)



// WEBPACK FOOTER //
// ./view/Components/Components.js